module.exports = __webpack_public_path__ + "static/media/MT5_adviser.8bb68d98.PNG";